import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.replace";

var imageUrl = function imageUrl(image, size) {
  return image.replace('s3-eu-west-1.amazonaws.com/pt-manufacturers-products', "manufacturers-products-images.papertrail.io/" + size + "x" + size);
};

export default imageUrl;